<template>
  <v-footer class="pa-3 grey lighten-1 justify-center" dark>
    <div class="brand-container">
      <span class="caption">Powered by</span>
      <!--<img src="../assets/logo.png"/>-->
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.brand-container {
  position: relative;
  height: 28px;
}
.caption {
  position: relative;
  float: left;
  height: 28px;
  line-height: 28px;
  padding-right: 7px;
}

img {
  height: 28px;
  padding: 3px;
}
</style>
